import React from 'react'

export default function MyBadge (props) {
  const width = props.width || 10
  const height = props.height || 10
  const color = props.color || 'white'
  const backgroundColor = props.backgroundColor || '#00D99F'
  const fontSize = props.fontSize || 12
  return (
    <div {...props} style={{ width: width, height: height, position: 'relative' }}>
      <sup style={{ position: 'absolute', top: 0, left: 0, width: width, height: height, backgroundColor: backgroundColor, borderBottomRightRadius: '100%', paddingRight: 8, paddingBottom: 8, fontSize: fontSize, color: color, overflow: 'hidden', lineHeight: 1.5 }}>
        {props.text}
      </sup>
    </div>
  )
}

export function MyBadgeDot (props) {
  const width = props.width || 10
  const height = props.height || 10
  const color = props.color || 'white'
  const backgroundColor = props.backgroundColor || '#F5004D'
  const fontSize = props.fontSize || 12
  return (
    <div {...props} style={{ position: 'relative' }}>
      <sup style={{ position: 'absolute', top: 0, left: 0, width: width, height: height, backgroundColor: backgroundColor, borderRadius: '50%', fontSize: fontSize, color: color }}>
        {props.text}
      </sup>
    </div>
  )
}
